export default {
    data() {
        return {
            mes_periodo: null,
            ano_periodo: null,
            allSelected: false,
            indeterminate: false,
            datos_razons: []
        }
    },
    async created() {
        this.mes_periodo = { id: this.fecha().fecha.mesHoy, name: this.gettersDatalist('list_mes', this.fecha().fecha.mesHoy)[0].name }
        this.ano_periodo = { id: this.fecha().fecha.anoHoy, name: this.gettersDatalist('list_ano', this.fecha().fecha.anoHoy)[0].name }
    },
    watch: {
        datos_razons(newVal, oldVal) {
            // Handle changes in individual flavour checkboxes
            if (newVal.length === 0) {
                this.indeterminate = false
                this.allSelected = false
            } else if (newVal.length === this.lists.datos_razon.filter(list => { list.id_list_estado.toString() === '1'; return list.id }).length) {
                this.indeterminate = false
                this.allSelected = true
            } else {
                this.indeterminate = true
                this.allSelected = false
            }
        }
    },
    methods: {
        toggleAll(checked) {
            let newRazons = []
            let newValue = this.lists.datos_razon.filter(list => list.id_list_estado.toString() === '1')
            for (let i = 0; i < newValue.length; i++) {
                newRazons.push(newValue[i].id)
            }
            this.datos_razons = checked ? newRazons : []
        },
    }
}